import React from 'react';

import { Button, useTranslation } from '@testsigma/atoms';

interface ViewDetailsFormActionsProps {
  handleClose(event: React.SyntheticEvent): void;
  handleEdit(event: React.SyntheticEvent): void;
}

const ViewDetailsFormActions: React.FC<ViewDetailsFormActionsProps> = (
  props: ViewDetailsFormActionsProps,
) => {
  const { handleClose, handleEdit } = props;

  const { t } = useTranslation();

  return (
    <div className='flex px-4 py-3 justify-between'>
      <Button type='secondary' onClick={handleClose}>
        {t('common.close')}
      </Button>
      <div>
        <Button type='secondary' className='ml-4' onClick={handleEdit}>
          {t('edit.connection.label')}
        </Button>
      </div>
    </div>
  );
};

export { ViewDetailsFormActions };
